import { type ValueOf } from '@models/helpers/custom'

export const FeeAccrualTypes = {
  INTERNAL: 'internal'
} as const

export type FeeAccrualType = ValueOf<typeof FeeAccrualTypes>

export type ChannelFeeType = {
  accrual_type: FeeAccrualType;
  percent: string;
  fixed: string | number;
  min_fixed: string | number;
  max_fixed: string | number;
  method?: string | null;
  terminal?: string | null;
}

export type RollingFeeType = {
  percent: string;
  cap?: string | null;
}

export type FeesType = {
  payment?: ChannelFeeType[];
  payout?: ChannelFeeType[];
  rolling?: RollingFeeType | null;
}
